import React from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const AccordionSummary = (props) => {
  return props.section.featuresText !== "" || props.section.benefitsText !== "" || props.section.documentFiles !== [] ? (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        color: props.summaryTextColor,
        backgroundColor: props.summaryBackgroundColor,
        padding: "1.2vw",
        cursor: "pointer",
        fontSize: "0.85vw",
      }}
      onClick={() => props.handler(props.section.id)}
    >
      <ExpandMoreIcon
        style={{
          color: props.iconColor,
          transform: props.expanded === props.section.id ? "rotate(180deg)" : "",
          marginRight: "0.85vw",
          transition: "0.1s",
          fontSize: "1vw",
        }}
      />
      {props.section.title}
    </div>
  ) : null;
};
export default AccordionSummary;
